import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaInfoCircle, FaPhoneAlt } from "react-icons/fa";
import "./Navbar.css";

function Navbar() {
  const location = useLocation();

  return (
    <nav className="navbar navbar-expand-lg custom-navbar shadow-sm">
      <div className="container d-flex align-items-center justify-content-between">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <img src="/images/erenlogo.png" alt="logo" className="navbar-logo" />
          <span className="animated-title">Eren Oto Yedek Parça</span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse ms-auto justify-content-end" id="navbarNav">
          <ul className="navbar-nav align-items-center gap-2">
            <li className="nav-item">
              <Link className={`nav-link d-flex align-items-center gap-1 ${location.pathname === "/" ? "active" : ""}`} to="/">
                <FaHome size={16} /> Anasayfa
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link d-flex align-items-center gap-1 ${location.pathname === "/about" ? "active" : ""}`} to="/about">
                <FaInfoCircle size={16} /> Hakkımızda
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link d-flex align-items-center gap-1 ${location.pathname === "/contact" ? "active" : ""}`} to="/contact">
                <FaPhoneAlt size={16} /> İletişim
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
